import * as enumKit from '@ts-max/enum';
const enumModule = enumKit;
export const createEnum = (enumModule.createEnum ??
    enumModule.default?.createEnum);
//# sourceMappingURL=enum-kit.js.map